  const NotFoundPage = () => {

    
    return (
      <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100 p-6">
        <img 
          src="./assets/error-image.svg" 
          alt="404 Error" 
          className="w-80 h-auto mb-6"
        />
        <h1 className="text-4xl font-bold text-gray-800 mb-4">404 - Page Not Found</h1>
        <p className="text-gray-600 text-lg mb-6 text-center">
          Sorry, the page you are looking for does not exist or has been moved.
        </p>
        <a 
          href="/" 
          className="px-6 py-3 bg-blue-600 text-white rounded-lg text-lg hover:bg-blue-700 transition"
        >
          Go Back Home
        </a>
      </div>
    );
  }
  
  export default NotFoundPage;
